import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@talentmesh/ui/components/button';
import { Link } from 'react-router-dom';
import DefaultErrorDescription from './Components/DefaultErrorDescription';
import ErrorDialog from './Components/ErrorDialog';
import ErrorQueryNames from './ErrorQueryNames';
import useQuery from '@/Hooks/UseQuery';
import UIStrings from '@/Utils/UIStrings';

function ErrorPage() {
    const titleFromQuery = useQuery(ErrorQueryNames.ErrorTitle);
    const descriptionFromQuery = useQuery(ErrorQueryNames.ErrorDescription);
    const renderLoginButton = useQuery(ErrorQueryNames.LoginAvailable);
    const { buildAuthorizeUrl } = useAuth0();

    const title = titleFromQuery || UIStrings.OopsError;
    const description = descriptionFromQuery || UIStrings.SomethingWentWrongLong;

    const clickHandler = async () => {
        window.location.href = await buildAuthorizeUrl();
    };

    return (
        <ErrorDialog
            errorTitle={title}
            errorBody={
                <div className="flex flex-col gap-1">
                    <DefaultErrorDescription errorDescription={description} />
                    {renderLoginButton && (
                        <Button type="button" variant="default" className="w-48 self-center" onClick={clickHandler}>
                            <Link to="/login">{UIStrings.LogIn}</Link>
                        </Button>
                    )}
                </div>
            }
        />
    );
}

export default ErrorPage;
